import * as React from 'react';
import Login from '../auth/login';
import { M3_LOGO } from '../navigation/Constants';

type Props = {
};

type States = {
};

class EmailVerifiedComponent extends React.Component<Props, States> {
  
  constructor(props: Props) {
    super(props);

    this.state = {
    };
  }

  // componentDidMount() {
    
  // }
  
  // componentWillUnmount() {
    
  // }

  render() {
    return(
      <div
        style={{backgroundColor: '#43464e', height: '100vh'}}
      >
        <div
          className="row justify-content-center align-items-center"
          style={{height: '100vh'}}
        >
          <div
            className="col-8"
          >
            <div className="row justify-content-center mt3 mb3">
              <div className="col-4">
                <img
                  id="sidebar_m3_logo"
                  src={M3_LOGO}
                  alt="M3_Logo"
                  title="M3_Logo"
                />
              </div>
            </div>
            <div className="row justify-content-center mt3 mb3">
              <div className="col-12">
                <h1
                  style={{
                    color: 'white',
                    textAlign: 'center'
                  }}
                >
                  Thank you for verifying your Email. One more step is left!
                </h1>
              </div>
            </div>
            <div className="row mt3">
              <div className="col-12">
                <h1
                  style={{
                    color: 'white',
                    textAlign: 'center'
                  }}
                >
                  Please log-in again to finalize the verfication. Thank you.
                </h1>
              </div>
            </div>
            <div className="row mt5">
              <div className="col-12">
                <Login isReLogin={false} fromEmailVerification={true} />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default EmailVerifiedComponent;



// WEBPACK FOOTER //
// ./src/commons/EmailVerifiedComponent.tsx